module.exports = __webpack_public_path__ + "img/irfan.77ca1fc8.jpeg";